import React from "react";
import { SelectOption } from "../../../../../types/select";
import { findSelectOption } from "../../../../libs/form";

type Primitive = string | number;

const isSelectOption = (item: unknown): item is SelectOption<string> | SelectOption<number> =>
  typeof item === "object" && item !== null && "value" in item && "label" in item;

const extractComparable = (
  item: Primitive | SelectOption<string> | SelectOption<number> | null | undefined
): Primitive | null => {
  if (item == null) return null;
  return isSelectOption(item) ? item.value : item;
};

const renderValue = (
  item?: Primitive | SelectOption<string> | SelectOption<number> | null,
  options?: SelectOption<string | number>[]
): string => {
  if (item == null) return "";

  if (isSelectOption(item)) return String(item.label);

  if (options) {
    const matched = findSelectOption(options, item);
    if (matched) return String(matched.label);
  }

  return String(item);
};

type EditableFieldProps = {
  isReadOnly: boolean;
  oldValue?: Primitive | null;
  newValue?: Primitive | SelectOption<string> | SelectOption<number> | null;
  options?: SelectOption[];
  children: React.ReactNode;
};

export const EditableField = (props: EditableFieldProps) => {
  const { isReadOnly, oldValue, newValue, options, children } = props;

  if (!isReadOnly) return <>{children}</>;

  const oldComparable = extractComparable(oldValue);
  const newComparable = extractComparable(newValue);

  const showOldValue = oldComparable !== null && newComparable !== null && oldComparable !== newComparable;

  return (
    <div className="ag-primary">
      {showOldValue && <s className="old-amount-text">{renderValue(oldValue, options)}</s>}{" "}
      {renderValue(newValue, options)}
    </div>
  );
};
